/**
 * Master list of product categories.
 * `id` is used as the key throughout the app — keep it lowercase + no spaces.
 */
const CATEGORIES = [
  { id: "all",       icon: "🏪", label: "All Products" },
  { id: "new",       icon: "✨", label: "New Arrivals"  },
  { id: "drinks",    icon: "🥤", label: "Drinks"        },
  { id: "energy",    icon: "⚡", label: "Energy Drinks" },
  { id: "chips",     icon: "🥔", label: "Chips"         },
  { id: "candies",   icon: "🍬", label: "Candies"       },
  { id: "cookies",   icon: "🍪", label: "Cookies"       },
  { id: "snacks",    icon: "🍿", label: "Snacks"        },
  { id: "fireworks", icon: "🎆", label: "Fireworks"     },
  { id: "household", icon: "🧴", label: "Household"     },
  { id: "other", icon: "📦", label: "Other"     },
];

export default CATEGORIES;
